import { Col, Row, Card, Table } from 'antd';
import React from 'react';
import { getColumnsWithHighlight, renderColumn } from '../../AllOrgActivities/helper';
import { adjEntryWithCard, adjEntryWithoutCard, columnsExtracter } from '../../AllOrgActivities/AdjSpldHelper';


export const AdjFscRate = ({ data, category }) => {

    const renderRegularGroup = (data, accAdjData, adjConfig) => {
      const accAdjAction =  accAdjData[0].action;
      const adjConfigAction = adjConfig[0].action
      const accAdjTitle = adjConfig[0]?.new_value ? "New Entry" : "Old Entry";
      const accAdjType = accAdjAction === "DELETE" ? "REMOVED" : "ADDED"
      const adjConfigType = adjConfigAction === "DELETE" ? "REMOVED" : "ADDED"
      const tableData = adjConfig[0]?.new_value?.cost ?? adjConfig[0]?.old_value?.cost;
      if(accAdjAction === "UPDATE" || adjConfigAction === "UPDATE" ) return null;
        return (
          <div className="mb-6">
            <h4
              className="ant-typography ant-typography-md font-medium mb-3"
              style={{ textAlign: "left", fontSize: "16px" }}
            >
              {accAdjTitle}
            </h4>
            <Card
             style={{
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
              marginBottom: "16px",
              padding: "2px",
            }}
            >
              {adjEntryWithCard(adjConfig, "",adjConfigType, adjConfigAction, category )}
              {adjEntryWithoutCard(accAdjData, "", accAdjType, accAdjAction)}
              {
                !_.isEmpty(tableData) && (
                  <Table
                    columns={columnsExtracter(tableData).map((col) => renderColumn(col,adjConfigType ))}
                    dataSource={tableData || []}
                    pagination={false}
                    bordered
                    scroll={{ x: 'max-content', y:`calc(100vh - 600px)` }}
                  />
                )
              }
            </Card>
          </div>
        );
    };

    const renderModifiedGroup = (data, accAdjData, adjConfig, rawData) => {
      const accAdjAction =  accAdjData[0].action;
      const adjConfigAction = adjConfig[0].action;
      const accAdjType = accAdjAction === "DELETE" ? "REMOVED" : "ADDED";
      const adjConfigType = adjConfigAction === "DELETE" ? "REMOVED" : "ADDED";
      const oldValues = adjConfig[0]?.old_value?.cost;
      const newValues = adjConfig[0]?.new_value?.cost;
      const newColumns = getColumnsWithHighlight(columnsExtracter(newValues), oldValues, newValues);
      const isOldAdjConfigPresent = !_.isEmpty(adjConfig[0].old_value);
      const isNewAdjConfigPresent = !_.isEmpty(adjConfig[0].new_value);

      if(rawData.action !== "UPDATE") return null;
        return (
            <div className="mb-6">
                <h4 className="ant-typography ant-typography-md font-medium mb-3" style={{ textAlign: 'left', fontSize: '16px' }}>Modified Entries</h4>
                <h5 className="ant-typography ant-typography-sm font-medium mb-2" style={{ textAlign: 'left', color: '#666', fontWeight: 'bold' }}>Previous Values</h5>
                <div className="mb-4">
                    <Card
                     style={{
                      background: "#fff",
                      borderRadius: "8px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
                      marginBottom: "16px",
                      padding: "2px",
                    }}
                    >
                       {isOldAdjConfigPresent && adjEntryWithCard(adjConfig, "",adjConfigType, "previous", category )}
                       {adjEntryWithoutCard(accAdjData, "", accAdjType, "previous")}
                       {
                        isOldAdjConfigPresent && (
                          <Table
                              columns={columnsExtracter(oldValues).map((col) => renderColumn(col,adjConfigType ))}
                              dataSource={oldValues}
                              pagination={false}
                              bordered
                              scroll={{ x: 'max-content', y:`calc(100vh - 600px)` }}
                          />
                        )
                       }
                    </Card>
                </div>
                <h5 className="ant-typography ant-typography-sm font-medium mb-2" style={{ textAlign: 'left', color: '#666', fontWeight: 'bold' }}>Updated Values</h5>
                <div>
                    <Card
                     style={{
                      background: "#fff",
                      borderRadius: "8px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
                      marginBottom: "16px",
                      padding: "2px",
                    }}
                    >
                      {isNewAdjConfigPresent && adjEntryWithCard(adjConfig, "",adjConfigType, "new", category )}
                       {adjEntryWithoutCard(accAdjData, "", accAdjType, "new")}
                       {
                        isNewAdjConfigPresent && (
                          <Table
                              columns={newColumns}
                              dataSource={newValues}
                              pagination={false}
                              bordered
                              scroll={{ x: 'max-content', y:`calc(100vh - 600px)` }}
                          />

                        )
                       }
                    </Card>
                </div>
            </div>
        );
    };

    const rawData = data ? data : [];
    const diffData = rawData?.difference[0] ? rawData?.difference[0] : [];
    const accAdjData = !_.isEmpty(diffData) && diffData?.account_adjustments;
    const adjConfig = !_.isEmpty(diffData) && diffData?.adjustment_configuration;

    const renderFuelSurchargeMain = () => {
        return (
            <div className="mt-6">
                <h4 className="ant-typography ant-typography-md font-medium mb-3" style={{ textAlign: 'left', fontSize: '18px' }}>
                    <span style={{ fontSize: '20px', color: '#395484' }}>FSC Rate Adjustments</span>
                    <div className="mt-6">
                        {renderRegularGroup(diffData, accAdjData,adjConfig)}
                        {renderModifiedGroup(diffData, accAdjData,adjConfig, rawData)}
                    </div>
                </h4>
            </div>
        );
    };

  return (
    <Row gutter={[16, 32]}>
        <Col span={24}>{renderFuelSurchargeMain()}</Col>
    </Row>
  );
};